import * as React from 'react';
import { FormLayoutWidget } from '../../../widgets/layout/FormLayoutWidget';
import { AppModel } from '@journeyapps-platform/lib-journey-core';
import { GroupedButtons } from '../../../widgets/buttons/GroupedButtons';
import { useSystem } from '../../../hooks/useSystem';
import { useDialogStore } from '../../../hooks/useDialogService';
import { v4 } from 'uuid';
import { styled } from '../../../theme';
import { useOrgStore } from '../../../hooks/useOrgStore';
import { SourceType } from '@journeyapps-platform/types-source-service';

export interface MigrateAppToGithubWidgetProps {
  app: AppModel;
  close: () => any;
}

export const MigrateAppToJourneyGitWidget: React.FC<MigrateAppToGithubWidgetProps> = (props) => {
  const { app } = props;
  const system = useSystem();
  const dialogStore = useDialogStore();
  const orgStore = useOrgStore();

  const getButtons = () => {
    return {
      key: 'submit',
      elements: [
        <GroupedButtons
          btns={[
            {
              label: 'Cancel',
              action: (event, loading) => {
                props.close();
              }
            },
            {
              label: 'Convert',
              action: async (event, loading) => {
                loading(true);
                const alpha = system.clientProvisioner.provisionAlphaClient();
                try {
                  await alpha.transferRepo({
                    app_id: app!.id,
                    target: {
                      type: SourceType.Internal,
                      properties: {
                        id: v4()
                      }
                    }
                  });
                  orgStore.org(app.org_id!).loadApps();
                  loading(false);
                  props.close();
                } catch (ex) {
                  loading(false);
                  dialogStore.errorDialog({
                    subTitle: 'Failed to migrate to JourneyApps Managed Git',
                    errorMessage: `Oh no, something went wrong and this app couldn't change git providers.`
                  });
                }
              }
            }
          ]}
        />
      ]
    };
  };

  return (
    <FormLayoutWidget
      sections={[
        {
          key: 'Source mode',
          elements: [<S.Text>This will migrate the application to Journey Managed Git.</S.Text>]
        },
        getButtons()
      ]}
    />
  );
};

namespace S {
  export const Text = styled.p`
    color: ${(p) => p.theme.text.primary};
  `;
}
